import { inject, Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { User } from './user.model';
import { HttpClient } from '@angular/common/http';

@Injectable({
	providedIn: 'root',
})
export class UserService {
	private readonly http = inject(HttpClient);

	getUser(): Observable<User | null> {
		return this.http.get<User>('/rest/user').pipe(catchError(() => of(null)));
	}

	logout(): Observable<any> {
		return this.http.get('/logout');
	}
}
